import React from 'react';

const StudentIssuesSkeletonLoader: React.FC = () => {
  return (
    <>
      {/* Info Bar Skeleton */}
      <div style={{
        padding: '16px 20px',
        borderBottom: '1px solid #f3f4f6',
        background: '#fafbfc',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div style={{
            width: '32px',
            height: '32px',
            borderRadius: '8px',
            background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 2s infinite'
          }}></div>
          <div style={{
            width: '200px',
            height: '16px',
            borderRadius: '8px',
            background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 2s infinite'
          }}></div>
        </div>
      </div>

      {/* Table Rows Skeleton */}
      <div style={{ padding: '20px' }}>
        {[...Array(10)].map((_, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '16px 20px',
              borderBottom: index < 9 ? '1px solid #f3f4f6' : 'none',
              animation: 'pulse 1.5s ease-in-out infinite',
              animationDelay: `${index * 0.1}s`
            }}
          >
            {/* Issue Title */}
            <div style={{ flex: '2', minWidth: 0 }}>
              <div style={{
                width: '80%',
                height: '16px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite',
                marginBottom: '8px'
              }}></div>
              <div style={{
                width: '60%',
                height: '12px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite'
              }}></div>
            </div>

            {/* Raised By */}
            <div style={{ flex: '1.5', minWidth: 0 }}>
              <div style={{
                width: '80%',
                height: '16px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite',
                marginBottom: '8px'
              }}></div>
              <div style={{
                width: '60%',
                height: '12px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite'
              }}></div>
            </div>

            {/* Student Name */}
            <div style={{ flex: '1.5', minWidth: 0 }}>
              <div style={{
                width: '80%',
                height: '16px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite',
                marginBottom: '8px'
              }}></div>
              <div style={{
                width: '60%',
                height: '12px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite'
              }}></div>
            </div>

            {/* Type Badge */}
            <div style={{ flex: '1', minWidth: 0 }}>
              <div style={{
                width: '80px',
                height: '28px',
                borderRadius: '20px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite'
              }}></div>
            </div>

            {/* Date */}
            <div style={{ flex: '1', minWidth: 0 }}>
              <div style={{
                width: '80px',
                height: '16px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite'
              }}></div>
            </div>

            {/* Status Badge */}
            <div style={{ flex: '1', minWidth: 0 }}>
              <div style={{
                width: '80px',
                height: '28px',
                borderRadius: '20px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite'
              }}></div>
            </div>

            {/* Actions */}
            <div style={{ flex: '0.5', minWidth: 0, textAlign: 'center' }}>
              <div style={{
                width: '36px',
                height: '36px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite',
                margin: '0 auto'
              }}></div>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination Skeleton */}
      <div style={{
        background: '#fafbfc',
        borderTop: '1px solid #e5e7eb',
        padding: '20px 16px',
        display: 'flex',
        justifyContent: 'center',
        gap: '8px'
      }}>
        {[...Array(7)].map((_, i) => (
          <div
            key={i}
            style={{
              width: '36px',
              height: '36px',
              borderRadius: '8px',
              background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 2s infinite'
            }}
          ></div>
        ))}
      </div>

      {/* Animation styles */}
      <style>{`
        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </>
  );
};

export default StudentIssuesSkeletonLoader;
